import { render } from "./HouseRents.vue?vue&type=template&id=dedce5a6&scoped=true"
import script from "./HouseRents.vue?vue&type=script&lang=js"
export * from "./HouseRents.vue?vue&type=script&lang=js"

import "./HouseRents.vue?vue&type=style&index=0&id=dedce5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedce5a6"]])

export default __exports__